/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as deviceV1 from "./keyapis_device_device_v1.pb"

/**
 * Системный сервис тэгов
 */

/**
 * Системный сервис тэгов
 */
export class SystemServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения статуса сервиса.
   * Не требует авторизации
   */
  GetSystemStatus = (req?: GetSystemStatusRequestDto, init?: RequestInit): Promise<GetSystemStatusResponseDto> => {
    return fm.request<GetSystemStatusRequestDto, GetSystemStatusResponseDto>(`${this.host}/device/api/v1/system/status${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Получение настроек автогенерации RFID.
   * Метод доступен для: admin, service
   */
  GetSystemRfidAutoGenerateSettings = (req?: GetSystemRfidAutoGenerateSettingsRequestDto, init?: RequestInit): Promise<GetSystemRfidAutoGenerateSettingsResponseDto> => {
    return fm.request<GetSystemRfidAutoGenerateSettingsRequestDto, GetSystemRfidAutoGenerateSettingsResponseDto>(`${this.host}/device/api/v1/system/rfid-auto-generate-settings${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Обновление настроек автогенерации RFID.
   * Метод доступен для: admin, service
   */
  PutSystemRfidAutoGenerateSettings = (req?: PutSystemRfidAutoGenerateSettingsRequestDto, init?: RequestInit): Promise<PutSystemRfidAutoGenerateSettingsResponseDto> => {
    return fm.request<PutSystemRfidAutoGenerateSettingsRequestDto, PutSystemRfidAutoGenerateSettingsResponseDto>(`${this.host}/device/api/v1/system/rfid-auto-generate-settings`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос получения настроек автогенерации RFID
 */
export type GetSystemRfidAutoGenerateSettingsRequestDto = {
}
/**
 * Ответ на запрос получения настроек автогенерации RFID
 */
export type GetSystemRfidAutoGenerateSettingsResponseDto = {
  /**
   * Настройки автогенерации RFID
   */
  data: RfidAutoGenerateSettingsResponseDto | null
}
/**
 * Запрос проверки доступности сервиса
 */
export type GetSystemStatusRequestDto = {
}
/**
 * Ответ на запрос проверки доступности сервиса
 */
export type GetSystemStatusResponseDto = {
}
/**
 * Запрос обновления настроек автогенерации RFID
 */
export type PutSystemRfidAutoGenerateSettingsRequestDto = {
  /**
   * Настройки автогенерации RFID
   */
  data?: RfidAutoGenerateSettingsRequestDto | null
}
/**
 * Ответ на запрос обновления настроек автогенерации RFID
 */
export type PutSystemRfidAutoGenerateSettingsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки автогенерации RFID
   */
  readonly data: RfidAutoGenerateSettingsResponseDto
  /**
   * Ошибка
   */
  readonly error: PutSystemRfidAutoGenerateSettingsResponseErrorDto
}>
/**
 * Ошибка запроса обновления настроек автогенерации RFID
 */
export type PutSystemRfidAutoGenerateSettingsResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса обновления настроек автогенерации RFID
 */
export type PutSystemRfidAutoGenerateSettingsResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorResponseDto
}>
/**
 * Настройки автогенерации RFID
 */
export type RfidAutoGenerateSettingsRequestDto = {
  /**
   * Признак включения автогенерации RFID
   */
  isEnabled: boolean
}
/**
 * Настройки автогенерации RFID
 */
export type RfidAutoGenerateSettingsResponseDto = {
  /**
   * Признак включения автогенерации RFID
   */
  isEnabled: boolean
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения настроек автогенерации RFID
   */
  "GetSystemRfidAutoGenerateSettingsRequest": {
    "kind": "class",
    "text": "Запрос получения настроек автогенерации RFID",
  },
  /**
   * Ответ на запрос получения настроек автогенерации RFID
   */
  "GetSystemRfidAutoGenerateSettingsResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек автогенерации RFID",
    "fields": {
      /**
       * Настройки автогенерации RFID
       */
      "data": {
        "type": "RfidAutoGenerateSettings",
        "text": "Настройки автогенерации RFID",
      },
    },
  },
  /**
   * Запрос проверки доступности сервиса
   */
  "GetSystemStatusRequest": {
    "kind": "class",
    "text": "Запрос проверки доступности сервиса",
  },
  /**
   * Ответ на запрос проверки доступности сервиса
   */
  "GetSystemStatusResponse": {
    "kind": "class",
    "text": "Ответ на запрос проверки доступности сервиса",
  },
  /**
   * Запрос обновления настроек автогенерации RFID
   */
  "PutSystemRfidAutoGenerateSettingsRequest": {
    "kind": "class",
    "text": "Запрос обновления настроек автогенерации RFID",
    "fields": {
      /**
       * Настройки автогенерации RFID
       */
      "data": {
        "type": "RfidAutoGenerateSettings",
        "text": "Настройки автогенерации RFID",
      },
    },
  },
  /**
   * Ответ на запрос обновления настроек автогенерации RFID
   */
  "PutSystemRfidAutoGenerateSettingsResponse": {
    "kind": "class",
    "text": "Ответ на запрос обновления настроек автогенерации RFID",
    "fields": {
      /**
       * Настройки автогенерации RFID
       */
      "data": {
        "type": "RfidAutoGenerateSettings",
        "text": "Настройки автогенерации RFID",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PutSystemRfidAutoGenerateSettingsResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса обновления настроек автогенерации RFID
   */
  "PutSystemRfidAutoGenerateSettingsResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса обновления настроек автогенерации RFID",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Настройки автогенерации RFID
   */
  "RfidAutoGenerateSettings": {
    "kind": "class",
    "text": "Настройки автогенерации RFID",
    "fields": {
      /**
       * Признак включения автогенерации RFID
       */
      "isEnabled": {
        "type": "bool",
        "text": "Признак включения автогенерации RFID",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}